var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGoogle = function SvgIconGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 29 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M28.4 14.472c0-1.152-.096-1.992-.302-2.863H14.685v5.196h7.873c-.159 1.291-1.016 3.236-2.92 4.542l-.027.174 4.24 3.22.294.028c2.699-2.442 4.254-6.035 4.254-10.297"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M14.684 28.16c3.857 0 7.095-1.244 9.46-3.39l-4.507-3.423c-1.207.825-2.826 1.4-4.953 1.4a8.58 8.58 0 0 1-8.127-5.817l-.167.014-4.41 3.344-.058.157c2.35 4.574 7.175 7.716 12.762 7.716"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M6.558 16.928a8.5 8.5 0 0 1-.476-2.769c0-.964.175-1.898.46-2.769l-.008-.185L2.07 7.807l-.146.068A13.8 13.8 0 0 0 .4 14.159c0 2.256.556 4.387 1.524 6.285z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M14.684 5.573c2.683 0 4.492 1.136 5.524 2.085L24.24 3.8C21.764 1.545 18.54.16 14.684.16 9.097.16 4.272 3.302 1.922 7.876l4.62 3.515c1.158-3.375 4.365-5.818 8.142-5.818"
  })));
};
export default SvgIconGoogle;